
const LOCAL_STORAGE_KEYS = {
    user: 'user',
    token: 'token'
  };
  
  export default LOCAL_STORAGE_KEYS;
  